import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Lightbulb, X } from "lucide-react";

// Info-bulle contextuelle ponctuelle : s'affiche une seule fois par utilisateur (clé),
// persistée via /onboarding/hint-seen. Le parent contrôle QUAND (prop `enabled`) et OÙ.
export default function HintBubble({ hintKey, title, body, enabled = true, className = "" }) {
  const { user, setUser } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const seen = (user?.hints_seen || []).includes(hintKey);
  if (!enabled || !user || user.role !== "client" || seen || dismissed) return null;

  const close = async () => {
    setDismissed(true);
    setUser({ ...user, hints_seen: [...(user.hints_seen || []), hintKey] });
    try { await api.post("/onboarding/hint-seen", { key: hintKey }); } catch { /* non bloquant */ }
  };

  return (
    <div data-testid={`hint-${hintKey}`} className={`relative rounded-2xl border border-sage/40 bg-sage/10 p-4 pr-9 flex gap-3 animate-pop ${className}`}>
      <span className="mt-0.5 shrink-0 w-8 h-8 rounded-full bg-sage/20 flex items-center justify-center">
        <Lightbulb size={16} className="text-sage" />
      </span>
      <div>
        <div className="text-sm font-semibold text-obsidian">{title}</div>
        <p className="mt-1 text-sm text-obsidian/70 leading-relaxed">{body}</p>
        <button data-testid={`hint-${hintKey}-dismiss`} onClick={close} className="mt-2 text-xs font-medium text-sage hover:underline">
          Compris
        </button>
      </div>
      <button onClick={close} aria-label="Fermer" className="absolute top-3 right-3 text-obsidian/40 hover:text-obsidian">
        <X size={15} />
      </button>
    </div>
  );
}
